import CommercialStagingForm from "./CommercialStagingForm"

const PosterDesignForm = () => {
    return(
        <CommercialStagingForm unitPrice={32} form_name="Poster Design" />
    )
}

export default PosterDesignForm;